<template>
  <div class="rate-body">
    <TopNavbar title="打分" rightText="发表" @clickRight="onClickPost" :is-loading="isPosting"></TopNavbar>
    <div class="rate-container">
      <UserItemRate :itemId="itemId" ref="itemRate" @rateResult="onRatePost"></UserItemRate>
    </div>
    <div class="item-box-container" v-if="itemId">
      <ItemBox :itemId="itemId"></ItemBox>
    </div>
  </div>
</template>

<script>
  import UserItemRate from "../common/UserItemRate";
  import TopNavbar from "../common/TopNavbar";
  import {Field, Toast} from "vant"
  import ItemBox from "../ugc_item/ItemBox";

  export default {
    name: "ItemRatePage",
    components: {ItemBox, TopNavbar, UserItemRate, Field},
    data() {
      return {
        itemId: 0,
        commentText: "",
        placeholder: "我的想法......",

        isPosting: false,
      }
    },
    mounted() {
      this.itemId = parseInt(this.$route.params.id)
      let rateParam = this.$route.query.rate
      if (rateParam) {
        this.$refs.itemRate.setRate(rateParam)
      }
    },
    methods: {
      async onClickPost() {
        if (this.isPosting) {
          return
        }

        this.isPosting = true
        await this.$refs.itemRate.onPost()
        this.isPosting = false
      },
      onRatePost(code) {
        if (code === 0) {
          Toast("评价成功")
          this.$router.go(-1)
        } else if (code === 20010) {
          this.$router.push("/login")
        } else  {
          this.$router.go(-1)
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .rate-body {
    padding-top: 35px;
  }

  .item-box-container {
  }
</style>
